const ratios = {
  SQUARE: "SQUARE",
  LANDSCAPE: "LANDSCAPE",
  PORTRAIT: "PORTRAIT",
};
const article = document.querySelector('.article')

function getAspectRatio(image) {
  const w = image.naturalWidth;
  const h = image.naturalHeight;

  let aspectRatio;

  if (w / h > 0.6 && w / h < 1.4) {
    aspectRatio = ratios.SQUARE;
  } else if (w > h) {
    aspectRatio = ratios.LANDSCAPE;
  } else {
    aspectRatio = ratios.PORTRAIT;
  }
  return aspectRatio;
}

const images = article.querySelectorAll("img");

images.forEach((image) => {
  image.classList.add("mask");
  if (getAspectRatio(image) === ratios.SQUARE) {
    image.classList.add("mask--square");
  } else if (getAspectRatio(image) === ratios.LANDSCAPE) {
    image.classList.add("mask--landscape");
  } else {
    image.classList.add("mask--portrait");
  }
});

function distributeColumnWidthsEvenly(tableSelector) {
  const tables = article.querySelectorAll(tableSelector);

  if (!tables) {
    console.error("Tables not found.");
    return;
  }

  tables.forEach((table) => {
    const firstRow = table.querySelector("tr");
    if (!firstRow) {
      console.error("No rows found in the table.");
      return;
    }

    const cells = firstRow.querySelectorAll("td, th"); // We gebruiken th voor geval dat er headers zijn

    const columnCount = cells.length;
    if (columnCount === 2) {
      table.querySelectorAll("tr").forEach((row) => {
        row.classList.add("table-two-columns-row");
      });
    } else {
      const columnWidthPercent = (100 / columnCount).toFixed(2); // 2 decimalen voor nauwkeurigheid
      table.style.minWidth = '800px';
      table.querySelectorAll("td, th").forEach((cell) => {
        cell.style.width = `${columnWidthPercent}%`;
      });
    }
  });
}

distributeColumnWidthsEvenly("table");
